import React from "react";
import { SelectField, selectInputStyles } from "@td/ui";
import { components } from "react-select";
import { translate } from "@td/shared_utils";
import { fieldTypes, statusCodes } from "../constants";
import { Status } from "../components";

const options = [
  {
    value: statusCodes.NOT_STARTED,
    label: translate(null, "care_team_tasks.statuses", "NOTSTARTED"),
  },
  {
    value: statusCodes.IN_PROGRESS,
    label: translate(null, "care_team_tasks.statuses", "INPROGRESS"),
  },
  {
    value: statusCodes.CANCELLED,
    label: translate(null, "care_team_tasks.statuses", "CANCELLED"),
  },
  {
    value: statusCodes.COMPLETED,
    label: translate(null, "care_team_tasks.statuses", "COMPLETED"),
  },
];

const CompactStatus = React.memo((props) => (
  <Status
    {...props}
    style={{
      padding: "0.125rem 0",
    }}
  />
));

const StatusField = React.memo(() => (
  <SelectField
    isSearchable={false}
    hideSelectedOptions
    name={fieldTypes.STATUS}
    options={options}
    className="status-field"
    label={translate(null, "care_team_tasks.form.fields.status", "label")}
    placeholder={translate(null, "care_team_tasks.form.fields.status", "placeholder")}
    components={{
      SingleValue: ({ data, ...props }) => (
        <components.SingleValue
          {...props}
          data={data}
        >
          <CompactStatus value={data["value"].replace("TASKSTATUS_", "")} />
        </components.SingleValue>
      ),
      Option: ({ value, ...props }) => (
        <components.Option
          {...props}
          value={value}
        >
          <CompactStatus value={value.replace("TASKSTATUS_", "")} />
        </components.Option>
      ),
    }}
    customStyles={{
      valueContainer: (provided, state) => ({
        ...provided,
        ...selectInputStyles.valueContainer(provided, state),
        paddingLeft: "0.5rem",
      }),
      placeholder: (provided, state) => ({
        ...provided,
        ...selectInputStyles.placeholder(provided, state),
        paddingLeft: "0.75rem",
      }),
      option: (provided, state) => ({
        ...provided,
        ...selectInputStyles.option(provided, state),
        paddingLeft: "0.25rem",
      }),
    }}
  />
));

export default StatusField;
